module.exports = __webpack_public_path__ + "media/images/team/SStavros-7408a5ab1502df4ad64dc8ddec61ad3c.jpg";